module.exports = __webpack_public_path__ + "img/assistencia_24h.30db741f.svg";